import SectionModel from "../../models/sectionModel";
import {
    CONTROL_TYPE,
    getCurrencyIcons,
    MODEL_CONTROL_TYPE,
    TYPE_SECTION_MODEL
} from "../../utils/enums";
import {getGlobalCurrency, isMobileWidth} from "../restaurant";
import {
    BUSINESS_APP_CONFIGURATION, BUSINESS_APP_CONFIGURATION_GET,
} from "../../store/reducers/restaurant/restaurant-actions";
import {createBreadcrumbModel} from "../createBreadcrumbModel";
import {createControlModel} from "../controlModelFactory";
import i18n from "../../i18n.js";

export function createBusinessAppSettingsModel({ ...args }) {
    return new SectionModel({
        columns: [
            {
                title: "settings.businessAppConfiguration.ACKNOWLEDGE_PREORDER",
                isEditable: true,
                accessor: 'acknowledgePreorder',
                isInline: true,
                type: CONTROL_TYPE.switch,
            },
            {
                title: "settings.businessAppConfiguration.SEND_COURIER_ASSIGNED_NOTIFICATION",
                isEditable: true,
                accessor: 'sendCourierAssignedNotification',
                isInline: true,
                type: CONTROL_TYPE.switch,
            },
            {
                title: "settings.businessAppConfiguration.ALWAYS_SHOW_CONSUMER_PHONE",
                isEditable: true,
                accessor: 'alwaysShowConsumerPhone',
                isInline: true,
                type: CONTROL_TYPE.switch,
            },
            // {
            //     title: "settings.businessAppConfiguration.HIDE_COURIER_PHONE_NUMBER",
            //     isEditable: true,
            //     accessor: 'hideCourierPhoneNumber',
            //     isInline: true,
            //     type: CONTROL_TYPE.switch,
            // },
            {
                title: "settings.businessAppConfiguration.HIDE_CONSUMER_NAME",
                isEditable: true,
                accessor: 'hideConsumerName',
                isInline: true,
                type: CONTROL_TYPE.switch,
            },
            // {
            //     title: "settings.businessAppConfiguration.SHOW_CASH_PAYMENT_INFO",
            //     isEditable: true,
            //     accessor: 'showCashPaymentInfo',
            //     isInline: true,
            //     type: CONTROL_TYPE.switch,
            // },
            {
                title: "settings.businessAppConfiguration.ALWAYS_SHOW_CONSUMER_ADDRESS",
                isEditable: true,
                accessor: 'alwaysShowConsumerAddress',
                isInline: true,
                type: CONTROL_TYPE.switch,
            },
            {
                title: "settings.businessAppConfiguration.INCLUDE_DELIVERY_PRICE",
                isEditable: true,
                accessor: 'includeDeliveryPrice',
                isInline: true,
                type: CONTROL_TYPE.switch,
            },
            // {
            //     title: "settings.businessAppConfiguration.SHOW_CREDIT_CARD_PAYMENT_INFO",
            //     isEditable: true,
            //     accessor: 'showCreditCardPaymentInfo',
            //     isInline: true,
            //     type: CONTROL_TYPE.switch,
            // },
            {
                title: "settings.businessAppConfiguration.SHOW_DRIVER_TIP",
                isEditable: true,
                accessor: 'showDriverTip',
                isInline: true,
                type: CONTROL_TYPE.switch,
            },
            {
                title: "settings.businessAppConfiguration.SHOW_ETA_FOR_NEXT_PICKUP_ONLY",
                isEditable: true,
                accessor: 'showETAForNextPickupOnly',
                isInline: true,
                type: CONTROL_TYPE.switch,
            },
            {
                title: "settings.businessAppConfiguration.SHOW_GLOBAL_DISCOUNT_INFO",
                isEditable: true,
                accessor: 'showGlobalDiscountInfo',
                isInline: true,
                type: CONTROL_TYPE.switch,
            },
            {
                title: "settings.businessAppConfiguration.SHOW_TOP_UP_TO_MINIMUM",
                isEditable: true,
                accessor: 'showTopUpToMinimum',
                isInline: true,
                type: CONTROL_TYPE.switch,
            },
            {
                title: "settings.businessAppConfiguration.DO_NOT_ALLOW_ASSISTANCE_ORDER_CREATION",
                isEditable: true,
                accessor: 'doNotAllowAssistOrderCreation',
                isInline: true,
                type: CONTROL_TYPE.switch,
            },
            {
                title: "settings.businessAppConfiguration.SHOW_SERVICE_FEE",
                isEditable: true,
                accessor: 'showServiceFee',
                isInline: true,
                type: CONTROL_TYPE.switch,
            },
            {
                title: "settings.businessAppConfiguration.SHOW_ALL_FEES_FOR_CASH_ORDERS",
                isEditable: true,
                accessor: 'showAllFeesForCashOrders',
                isInline: true,
                type: CONTROL_TYPE.switch,
            },
            {
                title: "settings.businessAppConfiguration.ALWAYS_SHOW_COOKING_TIME_SPAN",
                isEditable: true,
                accessor: 'alwaysShowCookingTimeSpan',
                isInline: true,
                type: CONTROL_TYPE.switch,
            },
            {
                title: "settings.businessAppConfiguration.REQUIRE_PHONE_NUMBER_ON_CREATION",
                isEditable: true,
                accessor: 'requirePhoneNumberOnOrderCreation',
                isInline: true,
                type: CONTROL_TYPE.switch,
            },
            {
                title: "settings.businessAppConfiguration.SEND_NEW_AGGREGATED_ORDER_NOTIFICATION_TO_DEPOT",
                isEditable: true,
                accessor: 'sendNewAggregatedOrderNotificationToDepot',
                isInline: true,
                type: CONTROL_TYPE.switch,
            },
            {
                title: "settings.businessAppConfiguration.HIDE_ORDER_DELIVERY_TIME",
                isEditable: true,
                accessor: 'hideDeliveryTime',
                isInline: true,
                type: CONTROL_TYPE.switch,
            },
            {
                title: "settings.businessAppConfiguration.SHOW_PREORDER_SPAN",
                isEditable: true,
                accessor: 'showPreorderSpan',
                isInline: true,
                isInteger: true,
                type: CONTROL_TYPE.number,
                measure: i18n.t("settings.settings.numericalSettings.TIME_MEASURE"),
            },
            {
                title: "settings.businessAppConfiguration.AUTO_ENABLE_TIMES",
                isEditable: true,
                accessor: 'autoEnableTimes',
                type: CONTROL_TYPE.arrayItems,
            },

            {
                title: "settings.businessAppConfiguration.DEPOT_BID_ENABLED",
                isEditable: true,
                accessor: 'depotBidEnabled',
                isInline: true,
                type: CONTROL_TYPE.switch,
            },
            {
                title: "settings.businessAppConfiguration.DEPOT_BID_PREDEFINED_VALUES",
                isEditable: true,
                accessor: 'depotBidPredefinedValues',
                isNumber: true,
                measure: getCurrencyIcons(getGlobalCurrency()),
                type: CONTROL_TYPE.arrayItems,
                isShow: item => item.depotBidEnabled,
            },
        ],
        actionName: BUSINESS_APP_CONFIGURATION,
        actionLoad: BUSINESS_APP_CONFIGURATION_GET,
        initNewItemModel: item => ({...item, depotBidPredefinedValues: item.depotBidPredefinedValues || []}),
        typeAction: args.typeAction,
        stayAfterSave: true,
        typeModel: TYPE_SECTION_MODEL.businessAppSettings,
        label: "settings.businessAppConfiguration.LABEL",
        breadcrumbs: [
            createBreadcrumbModel({ label: "header.menu.SETTINGS_LABEL" }),
        ],
        controls: [
            createControlModel({
                type: MODEL_CONTROL_TYPE.back,
                isShow: isMobileWidth,
            })
        ],
        mappingLambda: state => {
            return state.restaurant?.data?.businessAppSettings || {};
        }
    });
}
